import GlyphIcon from "./GlyphIcon.mjs";

const UnreadIcon= class extends GlyphIcon {
	render() {
		return(
			<GlyphIcon
				d="M30.30762,17.63232C28.25488,19.99805,22.751,25.5,16,25.5a13.7622,13.7622,0,0,1-4.67548-.85767l2.90863-2.90857a5.99943,5.99943,0,0,0,7.50068-7.50036l1.54126-1.54126a7.92362,7.92362,0,0,1-.51557,7.56763A25.33613,25.33613,0,0,0,27.74609,16a26.04838,26.04838,0,0,0-4.10992-3.669l2.16009-2.16015a29.01579,29.01579,0,0,1,4.51136,4.19678A2.49888,2.49888,0,0,1,30.30762,17.63232ZM27.21484,5.06055,5.06055,27.21436a1.49984,1.49984,0,0,1-2.1211-2.1211l3.26917-3.269a28.95112,28.95112,0,0,1-4.51624-4.1919,2.49922,2.49922,0,0,1,.001-3.2666C3.74512,12.002,9.249,6.5,16,6.5a13.716,13.716,0,0,1,4.67529.85779l4.41846-4.41834a1.49984,1.49984,0,0,1,2.12109,2.1211ZM8,16a7.94246,7.94246,0,0,1,1.24048-4.25977A25.33613,25.33613,0,0,0,4.25391,16,26.04838,26.04838,0,0,0,8.36383,19.669l.36108-.36109A7.9049,7.9049,0,0,1,8,16Zm9.764-5.731A5.93635,5.93635,0,0,0,16,10a6.00657,6.00657,0,0,0-6,6,5.9363,5.9363,0,0,0,.269,1.76392Z"
				{...this.props}
			/>
		);
	}
}

export default UnreadIcon;